/**
 * No-op analytics wrapper. Real analytics (GA4, GTM, Meta Pixel) will be
 * injected later through the future website settings "code injection" fields.
 * All UI code should call `trackEvent()` so events are ready to be routed
 * once a provider is wired up.
 */

const enabled = typeof window !== "undefined" && Boolean(window.__CS_ANALYTICS_ENABLED__);

export function trackEvent(name, payload = {}) {
    if (!enabled) {
        // Silent no-op in mock mode; log during development if opted-in.
        if (typeof window !== "undefined" && window.__CS_ANALYTICS_DEBUG__) {
            console.info("[analytics]", name, payload);
        }
        return;
    }
    // FUTURE BACKEND INTEGRATION: dispatch to the analytics provider here.
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: name, ...payload });
    }
}

export const AnalyticsEvents = {
    WHATSAPP_CLICK: "whatsapp_click",
    PHONE_CLICK: "phone_click",
    EMAIL_CLICK: "email_click",
    PRODUCT_VIEW: "product_view",
    PRODUCT_ENQUIRY_CLICK: "product_enquiry_click",
    CONTAINER_FILTER_USED: "container_filter_used",
    BLOG_VIEW: "blog_view",
};
